import { DatePipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { APP_AUDIENCE } from '@lib/core/environment/app-audience';
import { ConsultantModel } from '@lib/models/consultant/consultant.model';
import { OuiButton } from 'omnium-ui/button';
import { OuiPairInfo } from 'omnium-ui/pair-info';

@Component({
  selector: 'lib-fiche-consultant-profil',
  standalone: true,
  imports: [OuiPairInfo, OuiButton, DatePipe],
  templateUrl: './fiche-consultant-profil.component.html',
  styleUrl: './fiche-consultant-profil.component.scss',
})
export class FicheConsultantProfilComponent {
  readonly appAudience = inject(APP_AUDIENCE);

  readonly consultant = input.required<ConsultantModel>();
  readonly isGestionnaire = input<boolean>(false);
  readonly disableResiliation = input<boolean>(false);
  readonly requestResiliation = output();
}
